import React, { useState, Suspense } from 'react'
import { Link } from 'react-router-dom'

import LoadingBar from 'react-top-loading-bar'

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'
import styles from '../../App.module.css'
import classes from './404.module.css'

function Page404() {
    const [progress, setProgress] = useState(100);

    return (
        <>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                <Sidebar active="groups" />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                <div className={styles.main_content + ` main-content`}>
                    <div className={`${classes.error_info} p-4`}>
                        <div className={classes.content}>
                            <h1>404</h1>
                            <h2>oops! page not found</h2>
                            <Link className="button-center" to="/">Back to home</Link>
                        </div>
                    </div>
                    <Footer />
                </div>
                </Suspense>
            </div>
        </>
    )
}

export default Page404